function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4165 5.33335C20.4165 3.03217 22.282 1.16669 24.5832 1.16669C26.8844 1.16669 28.7498 3.03217 28.7498 5.33335V7.41669C28.7498 8.56728 29.6826 9.50002 30.8332 9.50002H37.0832C38.2338 9.50002 39.1665 10.4328 39.1665 11.5834V17.8334C39.1665 18.9839 38.2338 19.9167 37.0832 19.9167H34.9998C32.6986 19.9167 30.8332 21.7822 30.8332 24.0834C30.8332 26.3845 32.6986 28.25 34.9998 28.25H37.0832C38.2338 28.25 39.1665 29.1828 39.1665 30.3333V36.5833C39.1665 37.7339 38.2338 38.6667 37.0832 38.6667H30.8332C29.6826 38.6667 28.7498 37.7339 28.7498 36.5833V34.5C28.7498 32.1988 26.8844 30.3333 24.5832 30.3333C22.282 30.3333 20.4165 32.1988 20.4165 34.5V36.5833C20.4165 37.7339 19.4838 38.6667 18.3332 38.6667H12.0832C10.9326 38.6667 9.99984 37.7339 9.99984 36.5833V30.3333C9.99984 29.1828 9.0671 28.25 7.9165 28.25H5.83317C3.53198 28.25 1.6665 26.3845 1.6665 24.0834C1.6665 21.7822 3.53198 19.9167 5.83317 19.9167H7.9165C9.0671 19.9167 9.99984 18.9839 9.99984 17.8334V11.5834C9.99984 10.4328 10.9326 9.50002 12.0832 9.50002H18.3332C19.4838 9.50002 20.4165 8.56728 20.4165 7.41669V5.33335Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgPuzzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle);
export default __webpack_public_path__ + "static/media/puzzle.9bfa34a9.svg";
export { ForwardRef as ReactComponent };